import React from 'react';

// Router
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom'

// Firebase
import firebase from 'firebase/app'
import 'firebase/functions'

// Views
import SplashscreenComponent from './components/splashscreen/SplashscreenComponent';
import LoginComponent from './components/login/LoginComponent';
import HomePageComponent from './components/home/HomepageComponent'
import VerifyUserComponent from './components/verifyUser/VerifyUserComponent';
import WithdrawFundsComponent from './components/withdrawFunds/WithdrawFundsComponent';
import UsersControlComponent from './components/usersControl/UsersControlComponent';
import RankingComponent from './components/ranking/RankingComponent';

// Initialize Firebase
var firebaseConfig = {
  apiKey: "AIzaSyC-92sD9ocyIk_2ixzboXWMlSJ6JPT3Zes",
  authDomain: "inlabbeta.firebaseapp.com",
  projectId: "inlabbeta",
  storageBucket: "inlabbeta.appspot.com",
  messagingSenderId: "176503922048",
  appId: "1:176503922048:web:6a31e9b2b9b3588320f565"
};

firebase.initializeApp(firebaseConfig);

function App() {
  return (
    <Router>

      <Redirect to='/splash' />

      <Switch>
        <Route path='/splash' component={SplashscreenComponent} />
        <Route path='/login' component={LoginComponent} />
        <Route path='/home' component={HomePageComponent} />
        <Route path='/verify' component={VerifyUserComponent} />
        <Route path='/withdraw' component={WithdrawFundsComponent} />
        <Route path='/usersC' component={UsersControlComponent} />
        <Route path='/ranking' component={RankingComponent} />
      </Switch>
    </Router>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js